export default __webpack_public_path__ + "static/media/le_touquet9.2bcf18b0.jpg";